// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__WYSeo","tablist":"Tabs_tablist__7sKKf"};